module.exports = __webpack_public_path__ + "img/03_song_select.958b9a05.png";